import { useWindowDimensions } from "react-native";
import ridevueLogo from "../../assets/Logo/logos.svg";
import Image from "../Image/Image";
import H3 from "../Typography/H3";
import FontWeightType from "../../models/FontWeightType";
import Spinner from "../Spinner";
import { StyledFrame, StyledMainContent, StyledTextContainer } from "./styled";
import useGenericContentStore from "../../store/genericContent.store";

interface Props {
	show: boolean;
	text?: string;
	showSpinner?: boolean;
}

const LoadingIndicator = ({ show, text, showSpinner }: Props) => {
	const windowDimensions = useWindowDimensions();
	const { isNarrow } = useGenericContentStore((state) => ({ isNarrow: state.isNarrow }));

	if (!show) return null;

	return (
		// @ts-ignore
		<StyledMainContent isNarrow={isNarrow}>
			{/* @ts-ignore */}
			<StyledFrame isNarrow={isNarrow}>
				<Image
					source={{ uri: ridevueLogo }}
					windowDimensions={windowDimensions}
					width={isNarrow ? "344.395px" : "390px"}
					height={isNarrow ? "200px" : "223px"}
				/>
				{/* @ts-ignore */}
				<StyledTextContainer>
					{text && <H3 fontWeight={FontWeightType.Light}>{text}</H3>}
					{showSpinner && <Spinner show isStyle />}
				</StyledTextContainer>
			</StyledFrame>
		</StyledMainContent>
	);
};

export default LoadingIndicator;
